import 'animate.css';
import _ from 'lodash';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import CONSTANTS from '../constants';
import RANDOM_IMAGES from '../randomImages';
import GoogleHelper from './GoogleHelper';

export default class ViewHelper {
  static showAlertWithButtons(alert, isShowCancel, callBack, callbackClose) {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: alert.title,
      text: alert.text,
      showCancelButton: isShowCancel,
      confirmButtonText: `<a style="color:var(--button-font-color)"> ${alert.buttontxt} </a>`,
      cancelButtonText: `Close`,
      imageUrl: alert.icon,
      imageWidth: alert.width,
      imageHeight: alert.height,
      imageAlt: 'Custom image',
      confirmButtonColor: "var(--button-color)",
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }

    }).then((result) => {
      if (result.isConfirmed) {
        callBack();
      } else if (result.isDenied) {
        callbackClose();
      } else if (result.isDismissed) {
        callbackClose();
      }
    });
  }

  static showAlertWithButtonsDefualt(alert, isShowCancel, callBack, callbackClose) {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: alert.title,
      text: alert.text,
      showCancelButton: isShowCancel,
      confirmButtonText: `<a style="color:var(--button-font-color)"> ${alert.buttontxt} </a>`,
      cancelButtonText: `Close`,
      imageUrl: alert.icon,
      imageWidth: alert.width,
      imageHeight: alert.height,
      imageAlt: 'Custom image',
      confirmButtonColor: "var(--button-color)"
    }).then((result) => {
      if (result.isConfirmed) {
        callBack();
      } else if (result.isDenied) {
        callbackClose();
      } else if (result.isDismissed) {
        callbackClose();
      }
    });
  }


  static showAlertDefualtWithButtons(alert, isShowCancel, callBack, callbackClose) {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: alert.title,
      text: alert.text,
      showCancelButton: isShowCancel,
      confirmButtonText: '<a style="color:var(--button-font-color)"> Done </a>',
      cancelButtonText: `Close`,
      icon: alert.icon,
      confirmButtonColor: "var(--button-color)",

    }).then((result) => {
      console.log(result);
      if (result.isConfirmed) {
        callBack();
      } else if (result.isDenied) {
        callbackClose();
      } else if (result.isDismissed) {
        callbackClose();
      }
    });
  }

  static isWebview() {
    const navigator = window.navigator;
    const userAgent = navigator.userAgent;
    const normalizedUserAgent = userAgent.toLowerCase();
    const standalone = navigator.standalone;

    const isIos =
      /ip(ad|hone|od)/.test(normalizedUserAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isAndroid = /android/.test(normalizedUserAgent);
    const isSafari = /safari/.test(normalizedUserAgent);
    const isWebview =
      (isAndroid && /; wv\)/.test(normalizedUserAgent)) || (isIos && !standalone && !isSafari);

    return isWebview;
  }

  static showNetworkAlert(name) {
    this.showAlert({
      title: 'Internet Connection Error',
      text: name + ' couldn\'t connect to the internet. Please check your internet connection and try again.',
      icon: 'warning',
      confirmButtonText: 'Try Again'
    })
  }

  static showAlert(alert) {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: alert.title,
      text: alert.text,
      cancelButtonText: `OK`,
      icon: alert.icon,
      confirmButtonColor: "var(--button-color)",
    });
  }
  static showAlertSingleButton(alert, callback) {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: alert.title,
      text: alert.text,
      icon: alert.icon,
      confirmButtonText: `OK`,  // Changed to confirmButtonText
      confirmButtonColor: "var(--button-color)",
    }).then((result) => {
      if (result.isConfirmed) {
        // Execute the callback if provided
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
    });
  }
  static setDocumentTitle(title) {
    document.title = title;
  }
  static setDocumentDescription(desc) {
    if (document.getElementsByTagName('meta')) {
      document.getElementsByTagName('meta')["description"].content = desc;
    }
  }
  static setDocumentKeywords(desc) {
    if (document.getElementsByTagName('meta')) {
      document.getElementsByTagName('meta')["keywords"].content = desc;
    }
  }
  static setMetaKeywords(keywords) {
    let metaTag = document.querySelector('meta[name="keywords"]');

    // If the meta tag exists, update it
    if (metaTag) {
      metaTag.setAttribute('content', keywords);
    } else {
      // If it doesn't exist, create a new one
      metaTag = document.createElement('meta');
      metaTag.setAttribute('name', 'keywords');
      metaTag.setAttribute('content', keywords);
      document.head.appendChild(metaTag);
    }
  }
  static setCanonical(url) {
    let uc = document.querySelectorAll("link[rel='canonical']")[0];
    uc.setAttribute("href", url);
  }
  static toCurrency(amount, currency = '$', decimalPlaces = 2) {
    if (amount) {
      return `${currency} ${parseFloat(amount).toLocaleString(undefined, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
      })}`;
    }
    return '';
  }

  static toCurrencyWithZero(amount, currency = '$', decimalPlaces = 2) {
    return `${currency} ${parseFloat(amount).toLocaleString(undefined, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    })}`;
  }

  static toCurrencyWithNoDecimal(amount, currency = '$', decimalPlaces = 0) {
    return `${currency} ${parseFloat(amount).toLocaleString(undefined, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    })}`;
  }

  static toRating(rating) {
    return (rating / CONSTANTS.SETTINGS.RATING.SCALE_FACTOR).toFixed(1);
  }

  static ordersCount(tableOrders) {
    return tableOrders.length > 1 ? `${tableOrders.length} Orders` : `${tableOrders.length} Order`;
  }

  static itemsCount(tableOrders) {
    let itemsCount = _.sum(_.map(tableOrders, (tableOrder) => tableOrder.Order_Menu.length));
    return itemsCount > 1 ? `${itemsCount} Items` : `${itemsCount} Item`;
  }

  static getGoogleMapsLink(location) {
    return `http://www.google.com/maps/place/${location}`;
  }

  static getNumberLink(number) {
    return `tel:${number}`;
  }
  static capitalizeFirstLetter(string) {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static formatMinimumOrder(minimumOrder, currency, decimalPoint) {
    if (minimumOrder > 0)
      return `Min Order: ${ViewHelper.toCurrency(minimumOrder, currency, decimalPoint)}`;
    return 'No minimum order';
  }

  static assignRandomImage(locations) {
    locations.forEach((location, index) => {
      location.dummyImage = ViewHelper.getRandomLocationImage(index);
    });
  }

  static getRandomLocationImage(index) {
    return RANDOM_IMAGES[index % RANDOM_IMAGES.length];
  }

  static setCheckForDelivery() { }

  static getLocationsWithDistance(locations, currentLocation) {
    let newLocations = locations.map((location) => {
      let distance = '';
      if (currentLocation)
        distance = GoogleHelper.distanceBetweenTwoLatLngStrings(
          currentLocation,
          `${location.latitude},${location.longitude}`
        );
      return { ...location, distance };
    });
    newLocations.sort((a, b) => a.distance - b.distance);
    return newLocations;
  }

  static getPromotionTitles(promotions, location) {
    const titles = [];
    if (!promotions) return titles;
    if (promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET].length > 0) {
      let maxDis = -1,
        minLevel = 99999999,
        disType = 0,
        code = '';
      const basketProms = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET];
      for (let i = 0; i < basketProms.length; i++) {
        const {
          PromotionDiscount: { PromotionDiscountLevels: promotionDiscountLevels = [] }
        } = basketProms[i];
        if (promotionDiscountLevels.length === 0) continue;
        for (let j = 0; j < promotionDiscountLevels.length; j++) {
          const level = promotionDiscountLevels[j];
          if (level.expenditure < minLevel) minLevel = level.expenditure;

          let reward =
            level.reward_type === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.FIXED
              ? level.reward
              : (level.reward / 100) * level.expenditure;
          if (reward > maxDis) {
            maxDis = level.reward;
            disType = level.reward_type;
            code = basketProms[i].code;
          }
        }
      }
      titles.push(
        `${code.toUpperCase()}: Up to ${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
          ? `${maxDis}%`
          : this.toCurrency(maxDis, location.currency, location.decimal_places)
        } off on orders of ${this.toCurrency(
          minLevel,
          location.currency,
          location.decimal_places
        )} or above`
      );
    }

    if (promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS].length > 0) {
      let maxDis = -1,
        disType = 0,
        code = '';
      const allItemProms = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS];
      for (let i = 0; i < allItemProms.length; i++) {
        if (allItemProms[i].max_discount_amount > maxDis) {
          maxDis = allItemProms[i].PromotionDiscount.discount_amount;
          disType = allItemProms[i].PromotionDiscount.discount_amount_type;
          code = allItemProms[i].code;
        }
      }
      titles.push(
        `${code.toUpperCase()}: Up to ${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
          ? `${maxDis}%`
          : this.toCurrency(maxDis, location.currency, location.decimal_places)
        } off on all items.`
      );
    }

    let maxDis1 = -1;
    let maxDis2 = -1;
    let code1 = '';
    let code2 = '';
    const catKeys = Object.keys(
      promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES]
    );
    if (catKeys.length > 0) {
      const catObj = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES];
      for (let i = 0; i < catKeys.length; i++) {
        const prom = catObj[parseInt(catKeys[i])];
        if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.FIXED &&
          maxDis1 < prom.discount_amount
        ) {
          maxDis1 = prom.discount_amount;
          code1 = prom.code;
        } else if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.PERCENTAGE &&
          maxDis2 < prom.discount_amount
        ) {
          maxDis2 = prom.discount_amount;
          code2 = prom.code;
        }
      }
    }

    const itemKeys = Object.keys(
      promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS]
    );
    if (itemKeys.length > 0) {
      const catObj = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS];
      for (let i = 0; i < itemKeys.length; i++) {
        const prom = catObj[parseInt(itemKeys[i])];
        if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.FIXED &&
          maxDis1 < prom.discount_amount
        ) {
          maxDis1 = prom.discount_amount;
          code1 = prom.code;
        } else if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.PERCENTAGE &&
          maxDis2 < prom.discount_amount
        ) {
          maxDis2 = prom.discount_amount;
          code2 = prom.code;
        }
      }
    }

    let title = '';

    if (maxDis1 !== -1) {
      if (maxDis2 === -1 || code1 !== code2)
        titles.push(
          `${code1.toUpperCase()}: Up to ${this.toCurrency(
            maxDis1,
            location.currency,
            location.decimal_places
          )} off on specific items.`
        );
      else
        title = `${code1.toUpperCase()}: Up to ${this.toCurrency(
          maxDis1,
          location.currency,
          location.decimal_places
        )}`;
    }

    if (maxDis2 !== -1) {
      if (maxDis1 === -1 || code1 !== code2)
        titles.push(`${code2.toUpperCase()}: Up to ${maxDis2}% off on specific items.`);
      else title += ` or ${maxDis2}% off on specific items.`;
    }

    if (title !== '') titles.push(title);

    return titles;
  }

  static getCustomizedPromotionTitles(promotions, location) {
    const titles = [];
    if (!promotions) return titles;
    if (promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET].length > 0) {
      let maxDis = -1,
        minLevel = 99999999,
        disType = 0,
        code = '';
      const basketProms = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET];

      for (let i = 0; i < basketProms.length; i++) {
        const {
          PromotionDiscount: { PromotionDiscountLevels: promotionDiscountLevels = [] }
        } = basketProms[i];
        if (promotionDiscountLevels.length === 0) continue;
        for (let j = 0; j < promotionDiscountLevels.length; j++) {
          const level = promotionDiscountLevels[j];
          if (level.expenditure < minLevel) minLevel = level.expenditure;

          // to serve our purpose, it was needed to change title generation lofic

          maxDis =
            level.reward_type === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.FIXED
              ? basketProms[i].max_discount_amount
              : level.reward;
          disType = level.reward_type;
          code = basketProms[i].code;
          titles.push(
            `${code.toUpperCase()}: Up to ${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
              ? `${maxDis}%`
              : this.toCurrency(maxDis, location.currency, location.decimal_places)
            } off on orders of ${this.toCurrency(
              promotionDiscountLevels[j].expenditure,
              location.currency,
              location.decimal_places
            )} or above`
          );

          // below portion of code is from previous version

          // if (reward > maxDis) {
          //   maxDis = level.reward;
          //   disType = level.reward_type;
          //   code = basketProms[i].code;
          //   titles.push(`${code.toUpperCase()}: Up to ${disType == CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE ? `${maxDis}%` : this.toCurrency(maxDis, location.currency, location.decimal_places)} off on orders of ${this.toCurrency(minLevel, location.currency, location.decimal_places)} or above`);
          // }
        }
      }
    }

    if (promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS].length > 0) {
      let maxDis = -1,
        disType = 0,
        code = '';
      const allItemProms = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS];
      for (let i = 0; i < allItemProms.length; i++) {
        if (allItemProms[i].max_discount_amount > maxDis) {
          maxDis = allItemProms[i].PromotionDiscount.discount_amount;
          disType = allItemProms[i].PromotionDiscount.discount_amount_type;
          code = allItemProms[i].code;
          titles.push(
            `${code.toUpperCase()}: Up to ${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
              ? `${maxDis}%`
              : this.toCurrency(maxDis, location.currency, location.decimal_places)
            } off on all items.`
          );
          maxDis = -1;
        }
      }
    }

    let maxDis1 = -1;
    let maxDis2 = -1;
    let code1 = '';
    let code2 = '';
    const catKeys = Object.keys(
      promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES]
    );
    if (catKeys.length > 0) {
      const catObj = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES];
      for (let i = 0; i < catKeys.length; i++) {
        const prom = catObj[parseInt(catKeys[i])];
        if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.FIXED &&
          maxDis1 < prom.discount_amount
        ) {
          maxDis1 = prom.discount_amount;
          code1 = prom.code;
        } else if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.PERCENTAGE &&
          maxDis2 < prom.discount_amount
        ) {
          maxDis2 = prom.discount_amount;
          code2 = prom.code;
        }
      }
    }

    const itemKeys = Object.keys(
      promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS]
    );
    if (itemKeys.length > 0) {
      const catObj = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS];
      for (let i = 0; i < itemKeys.length; i++) {
        const prom = catObj[parseInt(itemKeys[i])];
        if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.FIXED &&
          maxDis1 < prom.discount_amount
        ) {
          maxDis1 = prom.discount_amount;
          code1 = prom.code;
        } else if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.PERCENTAGE &&
          maxDis2 < prom.discount_amount
        ) {
          maxDis2 = prom.discount_amount;
          code2 = prom.code;
        }
      }
    }

    let title = '';

    if (maxDis1 !== -1) {
      if (maxDis2 === -1 || code1 !== code2)
        titles.push(
          `${code1.toUpperCase()}: Up to ${this.toCurrency(
            maxDis1,
            location.currency,
            location.decimal_places
          )} off on specific items.`
        );
      else
        title = `${code1.toUpperCase()}: Up to ${this.toCurrency(
          maxDis1,
          location.currency,
          location.decimal_places
        )}`;
    }

    if (maxDis2 !== -1) {
      if (maxDis1 === -1 || code1 !== code2)
        titles.push(`${code2.toUpperCase()}: Up to ${maxDis2}% off on specific items.`);
      else title += ` or ${maxDis2}% off on specific items.`;
    }

    if (title !== '') titles.push(title);
    return titles;
  }


  static getCustomizedBinDiscountsTitles(bindiscounts, location) {
    let titles = [];
    if (!bindiscounts) return titles;

    if (bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET].length > 0) {
      let maxDis = -1,
        minLevel = 99999999,
        disType = 0,
        code = '',
        id = '';
      let basketProms = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET];
      for (let i = 0; i < basketProms.length; i++) {
        const {
          BindiscountDiscount: { BindiscountDiscountLevels: bindiscountDiscountLevels = [] }
        } = basketProms[i];

        if (bindiscountDiscountLevels.length === 0) continue;

        if (bindiscountDiscountLevels.length === 1) {
          const level = bindiscountDiscountLevels[0];
          if (level.expenditure < minLevel) minLevel = level.expenditure;

          // to serve our purpose, it was needed to change title generation lofic

          maxDis = level.reward;
          disType = level.reward_type;
          code = basketProms[i].code;
          id = basketProms[i].id;

          titles.push({
            code: basketProms[i].code,
            bank: basketProms[i].bank_name,
            msg: `${id}:<span class='fw-bold bin-start-ft-size card-font-color'><span class='highlight-color'>${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
              ? `${maxDis}%`
              : this.toCurrency(maxDis, location.currency, location.decimal_places)
              } off</span></span><span class='mt-1 card-font-color card-text-size'> on ${basketProms[i].bank_card_name.toLowerCase() + ' ' + basketProms[i].bank_card_type.toLowerCase() + ' ' + basketProms[i].bank_card_variant.toLowerCase()} card.</span>`
          });
          maxDis = -1;
        }

        if (bindiscountDiscountLevels.length > 1) {
          for (let j = 0; j < bindiscountDiscountLevels.length; j++) {
            const level = bindiscountDiscountLevels[j];
            if (level.expenditure < minLevel) minLevel = level.expenditure;

            // to serve our purpose, it was needed to change title generation lofic
            if (level.reward > maxDis) {

              maxDis = level.reward;
              disType = level.reward_type;
              code = basketProms[i].code;
              id = basketProms[i].id;

            }

          }
          titles.push({
            code: basketProms[i].code,
            bank: basketProms[i].bank_name,
            msg: `${id}:<span class='fw-bold bin-start-ft-size card-font-color'><span class='highlight-color'>Upto ${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
              ? `${maxDis}%`
              : this.toCurrency(maxDis, location.currency, location.decimal_places)
              } off </span></span><span class='mt-1 card-font-color card-text-size'>  on ${basketProms[i].bank_card_name.toLowerCase() + ' ' + basketProms[i].bank_card_type.toLowerCase() + ' ' + basketProms[i].bank_card_variant.toLowerCase()} card.</span>`
          });
          maxDis = -1;
        }
      }
    }

    if (bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS].length > 0) {
      let maxDis = -1,
        disType = 0,
        code = '',
        id = ''
      let allItemProms = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS];
      for (let i = 0; i < allItemProms.length; i++) {
        if (allItemProms[i].max_discount_amount > maxDis) {
          maxDis = allItemProms[i].BindiscountDiscount.discount_amount;
          disType = allItemProms[i].BindiscountDiscount.discount_amount_type;
          code = allItemProms[i].code;
          id = allItemProms[i].id;
          titles.push(
            {
              code: allItemProms[i].code,
              bank: allItemProms[i].bank_name,
              msg: `${id}:<span class='fw-bold bin-start-ft-size card-font-color'><span class='highlight-color'>${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
                ? `${maxDis}%`
                : this.toCurrency(maxDis, location.currency, location.decimal_places)
                } off </span></span><span class='mt-1 card-font-color card-text-size'> on all items with ${allItemProms[i].bank_card_name.toLowerCase() + ' ' + allItemProms[i].bank_card_type.toLowerCase() + ' ' + allItemProms[i].bank_card_variant.toLowerCase()} card.</span>`
            });
          maxDis = -1;
        }
      }
    }

    let maxDis1 = -1;
    let maxDis2 = -1;
    let code1 = '';
    let code2 = '';
    let id1 = '';
    let id2 = '';
    let card_name = '';
    let card_type = '';
    let card_variant = '';
    let newBank = '';
    const catKeys = Object.keys(
      bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES]
    );
    if (catKeys.length > 0) {
      const catObj = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES];
      for (let i = 0; i < catKeys.length; i++) {
        const prom = catObj[parseInt(catKeys[i])];
        if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.FIXED &&
          maxDis1 < prom.discount_amount
        ) {
          maxDis1 = prom.discount_amount;
          code1 = prom.code;
          id1 = prom.id;
          card_name = prom.bank_card_name;
          card_type = prom.bank_card_type;
          card_variant = prom.bank_card_variant;
          newBank = prom.bank_name;
        } else if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.PERCENTAGE &&
          maxDis2 < prom.discount_amount
        ) {
          maxDis2 = prom.discount_amount;
          code2 = prom.code;
          id2 = prom.id;
          card_name = prom.bank_card_name;
          card_type = prom.bank_card_type;
          card_variant = prom.bank_card_variant;
          newBank = prom.bank_name;
        }
      }
    }

    const itemKeys = Object.keys(
      bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS]
    );
    if (itemKeys.length > 0) {
      const catObj = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS];
      for (let i = 0; i < itemKeys.length; i++) {

        const prom = catObj[parseInt(itemKeys[i])];
        const discount = prom.BindiscountDiscount.BindiscountDiscountItems.filter((row) => row.item = parseInt(itemKeys[i]));
        if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.FIXED &&
          maxDis1 < prom.discount_amount
        ) {
          maxDis1 = prom.discount_amount;
          code1 = prom.code;
          id1 = prom.id;
          card_name = prom.bank_card_name;
          card_type = prom.bank_card_type;
          card_variant = prom.bank_card_variant;
          newBank = prom.bank_name;

        } else if (
          prom.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.PERCENTAGE &&
          maxDis2 < prom.discount_amount
        ) {
          maxDis2 = prom.discount_amount;
          code2 = prom.code;
          id2 = prom.id;
          card_name = prom.bank_card_name;
          card_type = prom.bank_card_type;
          card_variant = prom.bank_card_variant;
          newBank = prom.bank_name;
        }
      }
    }

    let title = '';

    if (maxDis1 !== -1) {
      if (maxDis2 === -1 || id1 !== id2) {
        titles.push({
          code: code1,
          bank: newBank,
          msg: `${id1}:<span class='fw-bold bin-start-ft-size card-font-color'><span class='highlight-color'>Upto ${this.toCurrency(
            maxDis1,
            location.currency,
            location.decimal_places
          )} off </span></span><span class='mt-1 card-font-color card-text-size-specific'> on specific items with ${card_name.toLowerCase() + ' ' + card_type.toLowerCase() + ' ' + card_variant.toLowerCase()} card.</span>`
        });
      } else {

        title = `${id1}: Up to ${this.toCurrency(
          maxDis1,
          location.currency,
          location.decimal_places
        )}`;
      }
    }

    if (maxDis2 !== -1) {
      if (maxDis1 === -1 || id1 !== id2) {

        titles.push({
          code: code2,
          bank: newBank,
          msg: `${id2}:<span class='fw-bold bin-start-ft-size card-font-color' ><span class='highlight-color'>Upto ${maxDis2}% off </span></span><span class='mt-1 card-font-color card-text-size-specific' > on specific items with ${card_name.toLowerCase() + ' ' + card_type.toLowerCase() + ' ' + card_variant.toLowerCase()} card.</span>`
        });
      } else {

        title += ` or ${maxDis2}% off on specific items with ${card_name + ' ' + card_type + ' ' + card_variant} card .`;
      }
    }

    if (title !== '') titles.push(title);
    return titles;
  }
  static capitalizeFirstLetter(string) {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  static getCustomizedBinDiscounts(bindiscounts, location) {
    const titles = [];
    if (!bindiscounts) return titles;
    if (bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET].length > 0) {
      let maxDis = -1,
        minLevel = 99999999,
        disType = 0,
        code = '';
      const basketProms = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET];

      for (let i = 0; i < basketProms.length; i++) {
        const {
          BindiscountDiscount: { BindiscountDiscountLevels: bindiscountDiscountLevels = [] }
        } = basketProms[i];
        if (bindiscountDiscountLevels.length === 0) continue;
        if (bindiscountDiscountLevels.length === 1) {
          const level = bindiscountDiscountLevels[0];
          if (level.expenditure < minLevel) minLevel = level.expenditure;

          // to serve our purpose, it was needed to change title generation lofic

          maxDis =
            level.reward_type === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.FIXED
              ? basketProms[i].max_discount_amount
              : level.reward;
          disType = level.reward_type;
          code = basketProms[i].code;
          let binText =
            `<span class='fw-bold fs-5 highlight-color'>${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
              ? `${maxDis}%`
              : this.toCurrency(maxDis, location.currency, location.decimal_places)
            } off</span><span class='card-font-color'> on ${this.capitalizeFirstLetter(basketProms[i].bank_card_name) + ' ' + this.capitalizeFirstLetter(basketProms[i].bank_card_type) + ' ' + this.capitalizeFirstLetter(basketProms[i].bank_card_variant)} Card.</span>`;
          basketProms[i].binText = binText;
          titles.push(basketProms[i]);
          maxDis = -1;
        }
        if (bindiscountDiscountLevels.length > 1) {
          for (let j = 0; j < bindiscountDiscountLevels.length; j++) {
            const level = bindiscountDiscountLevels[j];
            if (level.expenditure < minLevel) minLevel = level.expenditure;

            if (level.reward > maxDis) {
              maxDis =
                level.reward_type === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.FIXED
                  ? basketProms[i].max_discount_amount
                  : level.reward;
              disType = level.reward_type;
              code = basketProms[i].code;
            }
          }
          let binText =
            `<span class='fw-bold fs-5 highlight-color'>Upto ${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
              ? `${maxDis}%`
              : this.toCurrency(maxDis, location.currency, location.decimal_places)
            } off</span><span class='card-font-color'> on ${this.capitalizeFirstLetter(basketProms[i].bank_card_name) + ' ' + this.capitalizeFirstLetter(basketProms[i].bank_card_type) + ' ' + this.capitalizeFirstLetter(basketProms[i].bank_card_variant)} Card.</span>`;
          basketProms[i].binText = binText;
          titles.push(basketProms[i]);
          maxDis = -1;
        }
      }
    }

    if (bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS].length > 0) {
      let maxDis = -1,
        disType = 0,
        code = '';
      const allItemProms = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS];
      for (let i = 0; i < allItemProms.length; i++) {
        if (allItemProms[i].max_discount_amount > maxDis) {
          maxDis = allItemProms[i].BindiscountDiscount.discount_amount;
          disType = allItemProms[i].BindiscountDiscount.discount_amount_type;
          code = allItemProms[i].code;
          let binText =
            `<span class='fw-bold fs-5 highlight-color'>${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
              ? `${maxDis}%`
              : this.toCurrency(maxDis, location.currency, location.decimal_places)
            } off</span><span class='card-font-color'> on ${this.capitalizeFirstLetter(allItemProms[i].bank_card_name) + ' ' + this.capitalizeFirstLetter(allItemProms[i].bank_card_type) + ' ' + this.capitalizeFirstLetter(allItemProms[i].bank_card_variant)} Card.</span>`;
          allItemProms[i].binText = binText;
          titles.push(allItemProms[i]);
          maxDis = -1;
        }
      }
    }

    let maxDis1 = -1;
    let maxDis2 = -1;
    let code1 = '';
    let code2 = '';
    let card_name = '';
    let card_type = '';
    let card_variant = '';
    let promo = '';
    let staticPromos = [];

    const catKeys = Object.keys(
      bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES]
    );
    if (catKeys.length > 0) {
      const catObj = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES];
      for (let i = 0; i < catKeys.length; i++) {
        const prom = catObj[parseInt(catKeys[i])];
        staticPromos.push(prom);
      }
    }

    const itemKeys = Object.keys(
      bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS]
    );
    if (itemKeys.length > 0) {
      const catObj = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS];
      for (let i = 0; i < itemKeys.length; i++) {
        const prom = catObj[parseInt(itemKeys[i])];
        staticPromos.push(prom);
      }
    }

    let maxDis = -1,
      disType = 0,
      code = '';


    staticPromos = _.map(
      _.groupBy(staticPromos, 'code'),
      g => _.maxBy(g, 'discount_amount')
    )

    for (let i = 0; i < staticPromos.length; i++) {
      let prom = staticPromos[i];
      maxDis = prom.discount_amount;
      disType = prom.discount_amount_type;
      code = prom.code;
      let binText =
        `<span class='fw-bold fs-5 highlight-color'>${disType === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
          ? `${maxDis}%`
          : this.toCurrency(maxDis, location.currency, location.decimal_places)
        } off</span><span class='card-font-color'> on specific items with ${this.capitalizeFirstLetter(prom.bank_card_name) + ' ' + this.capitalizeFirstLetter(prom.bank_card_type) + ' ' + this.capitalizeFirstLetter(prom.bank_card_variant)} Card.</span>`;
      prom.binText = binText;
      titles.push(prom);

    }

    let title = '';
    if (title !== '') {
      let binText = title;
      promo.binText = binText;
      titles.push(promo);
    };
    let sortedTitles = [];
    let banks = _.uniq(_.map(titles, 'bank_name'));
    for (let i = 0; i < banks.length; i++) {
      let binDiscount = _.filter(titles, (obj) => obj.bank_name === banks[i]);
      let bankDetails = _.find(titles, (obj) => obj.bank_name === banks[i]);
      let discount = {
        bank_name: banks[i],
        bank_img: bankDetails.bank_img_url,
        bank_rect_img: bankDetails.bank_rect_img_url,
        bindiscounts: binDiscount
      }
      sortedTitles.push(discount);
    }
    return sortedTitles;
  }

  static getDiscountedItemPrice(price, itemId, categoryId, promotions, order_type_id, orderTypes) {
    if (!promotions)
      return {
        discountedPrice: price,
        appliedPromo: null,
        discountAmount: 0,
        discountAmountType: 0
      };


    // if (order_type_id) {
    //   const orderTypeloc = _.find(orderTypes, (o) => o.id === parseInt(order_type_id));
    //   let orderTypeObjects = [];
    //   if (promotions.currentManualPromoID) {
    //     orderTypeObjects = promotions.currentManualPromoID.orderTypes;
    //     const orderTypeIds = orderTypeObjects.map((o) => o.OrderType.order_type);
    //     if (orderTypeIds.indexOf(orderTypeloc.order_type) < 0) {
    //       return {
    //         discountedPrice: price,
    //         appliedPromo: null,
    //         discountAmount: 0,
    //         discountAmountType: 0
    //       };
    //     }
    //   }
    // }

    const discounts = {};

    price = parseInt(price);
    let discountedPrice = price;
    let appliedPromo = null;
    let discountAmount = 0;
    let discountAmountType = null;

    let currentDiscount = price;
    let currentPromo = null;
    let currentDiscountAmount = 0;
    let currentDiscountAmountType = null;

    if (promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS].length > 0) {
      const allItemProms = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS];
      for (let i = 0; i < allItemProms.length; i++) {
        const dis = allItemProms[i].PromotionDiscount;
        if (order_type_id) {
          const orderTypeloc = _.find(orderTypes, (o) => o.id === parseInt(order_type_id));
          const orderTypeObjects = allItemProms[i].PromotionOrderTypes;
          const orderTypeIds = orderTypeObjects.filter((o) => o.OrderType.active).map((o) => o.OrderType.order_type);
          if (orderTypeIds.indexOf(orderTypeloc.order_type) < 0) {
            return {
              discountedPrice: price,
              appliedPromo: null,
              discountAmount: 0,
              discountAmountType: 0
            };
          }
        }
        if (
          dis.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
        ) {
          const newPrice = price - (dis.discount_amount / 100) * price;
          if (newPrice < currentDiscount) {
            currentDiscount = newPrice;
            currentPromo = allItemProms[i].id;
            currentDiscountAmount = dis.discount_amount;
            currentDiscountAmountType = dis.discount_amount_type;
          }
        } else {
          const newPrice = price - dis.discount_amount;
          if (newPrice < currentDiscount) {
            currentDiscount = newPrice;
            currentPromo = allItemProms[i].id;
            currentDiscountAmount = dis.discount_amount;
            currentDiscountAmountType = dis.discount_amount_type;
          }
        }
      }
    }

    if (currentDiscount < 0) currentDiscount = 0;

    if (currentDiscount < price) {
      if (currentDiscount < discountedPrice) {
        discountedPrice = currentDiscount;
        appliedPromo = currentPromo;
        discountAmount = currentDiscountAmount;
        discountAmountType = currentDiscountAmountType;
      }
      discounts[currentPromo] = {
        discountAmount: currentDiscountAmount,
        discountAmountType: currentDiscountAmountType
      };

      currentPromo = null;
      currentDiscount = price;
      currentDiscountAmount = 0;
      currentDiscountAmountType = null;
    }

    const catObj = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES];
    if (catObj[categoryId]) {
      const dis = catObj[categoryId];
      if (order_type_id) {
        const orderTypeloc = _.find(orderTypes, (o) => o.id === parseInt(order_type_id));
        const orderTypeObjects = dis.orderTypes;
        const orderTypeIds = orderTypeObjects.filter((o) => o.OrderType.active).map((o) => o.OrderType.order_type);
        if (orderTypeIds.indexOf(orderTypeloc.order_type) < 0) {
          return {
            discountedPrice: price,
            appliedPromo: null,
            discountAmount: 0,
            discountAmountType: 0
          };
        }
      }
      if (
        dis.discount_amount_type === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
      ) {
        const newPrice = price - (dis.discount_amount / 100) * price;
        if (newPrice < currentDiscount) {
          currentDiscount = newPrice;
          currentPromo = catObj[categoryId].parent_id;
          currentDiscountAmount = dis.discount_amount;
          currentDiscountAmountType = dis.discount_amount_type;
        }
      } else {
        const newPrice = price - dis.discount_amount;
        if (newPrice < currentDiscount) {
          currentDiscount = newPrice;
          currentPromo = catObj[categoryId].parent_id;
          currentDiscountAmount = dis.discount_amount;
          currentDiscountAmountType = dis.discount_amount_type;
        }
      }
    }

    if (currentDiscount < 0) currentDiscount = 0;

    if (currentDiscount < price) {
      if (currentDiscount < discountedPrice) {
        discountedPrice = currentDiscount;
        appliedPromo = currentPromo;
        discountAmount = currentDiscountAmount;
        discountAmountType = currentDiscountAmountType;
      }
      discounts[currentPromo] = {
        discountAmount: currentDiscountAmount,
        discountAmountType: currentDiscountAmountType
      };
      currentPromo = null;
      currentDiscount = price;
      currentDiscountAmount = 0;
      currentDiscountAmountType = null;
    }

    const itemObj = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS];
    if (itemObj[itemId]) {
      const dis = itemObj[itemId];
      if (order_type_id) {
        const orderTypeloc = _.find(orderTypes, (o) => o.id === parseInt(order_type_id));
        const orderTypeObjects = dis.orderTypes;
        const orderTypeIds = orderTypeObjects.filter((o) => o.OrderType.active).map((o) => o.OrderType.order_type);
        if (orderTypeIds.indexOf(orderTypeloc.order_type) < 0) {
          return {
            discountedPrice: price,
            appliedPromo: null,
            discountAmount: 0,
            discountAmountType: 0
          };
        }
      }
      if (
        dis.discount_amount_type === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
      ) {
        const newPrice = price - (dis.discount_amount / 100) * price;
        if (newPrice < currentDiscount) {
          currentDiscount = newPrice;
          currentPromo = itemObj[itemId].parent_id;
          currentDiscountAmount = dis.discount_amount;
          currentDiscountAmountType = dis.discount_amount_type;
        }
      } else {
        const newPrice = price - dis.discount_amount;
        if (newPrice < currentDiscount) {
          currentDiscount = newPrice;
          currentPromo = itemObj[itemId].parent_id;
          currentDiscountAmount = dis.discount_amount;
          currentDiscountAmountType = dis.discount_amount_type;
        }
      }
    }

    if (currentDiscount < 0) currentDiscount = 0;

    if (currentDiscount < price) {
      if (currentDiscount < discountedPrice) {
        discountedPrice = currentDiscount;
        appliedPromo = currentPromo;
        discountAmount = currentDiscountAmount;
        discountAmountType = currentDiscountAmountType;
      }
      discounts[currentPromo] = {
        discountAmount: currentDiscountAmount,
        discountAmountType: currentDiscountAmountType
      };
    }

    discounts['discountedPrice'] = discountedPrice;
    discounts['appliedPromo'] = appliedPromo;
    discounts['discountAmount'] = discountAmount;
    discounts['discountAmountType'] = discountAmountType;

    return discounts;
  }

  static getBinDiscountedItemPrice(price, itemId, categoryId, bindiscounts) {
    if (!bindiscounts)
      return {
        discountedPrice: price,
        appliedPromo: null,
        discountAmount: 0,
        discountAmountType: 0
      };

    const discounts = {};

    price = parseInt(price);
    let discountedPrice = price;
    let appliedPromo = null;
    let discountAmount = 0;
    let discountAmountType = null;

    let currentDiscount = price;
    let currentPromo = null;
    let currentDiscountAmount = 0;
    let currentDiscountAmountType = null;

    if (bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS].length > 0) {
      const allItemProms = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ALL_ITEMS];
      for (let i = 0; i < allItemProms.length; i++) {
        const dis = allItemProms[i].BindiscountDiscount;
        if (
          dis.discount_amount_type ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
        ) {
          const newPrice = price - (dis.discount_amount / 100) * price;
          if (newPrice < currentDiscount) {
            currentDiscount = newPrice;
            currentPromo = allItemProms[i].id;
            currentDiscountAmount = dis.discount_amount;
            currentDiscountAmountType = dis.discount_amount_type;
          }
        } else {
          const newPrice = price - dis.discount_amount;
          if (newPrice < currentDiscount) {
            currentDiscount = newPrice;
            currentPromo = allItemProms[i].id;
            currentDiscountAmount = dis.discount_amount;
            currentDiscountAmountType = dis.discount_amount_type;
          }
        }
      }
    }

    if (currentDiscount < 0) currentDiscount = 0;

    if (currentDiscount < price) {
      if (currentDiscount < discountedPrice) {
        discountedPrice = currentDiscount;
        appliedPromo = currentPromo;
        discountAmount = currentDiscountAmount;
        discountAmountType = currentDiscountAmountType;
      }
      discounts[currentPromo] = {
        discountAmount: currentDiscountAmount,
        discountAmountType: currentDiscountAmountType
      };

      currentPromo = null;
      currentDiscount = price;
      currentDiscountAmount = 0;
      currentDiscountAmountType = null;
    }

    const catObj = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.CATEGORIES];
    if (catObj[categoryId]) {
      const dis = catObj[categoryId];
      if (
        dis.discount_amount_type === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
      ) {
        const newPrice = price - (dis.discount_amount / 100) * price;
        if (newPrice < currentDiscount) {
          currentDiscount = newPrice;
          currentPromo = catObj[categoryId].parent_id;
          currentDiscountAmount = dis.discount_amount;
          currentDiscountAmountType = dis.discount_amount_type;
        }
      } else {
        const newPrice = price - dis.discount_amount;
        if (newPrice < currentDiscount) {
          currentDiscount = newPrice;
          currentPromo = catObj[categoryId].parent_id;
          currentDiscountAmount = dis.discount_amount;
          currentDiscountAmountType = dis.discount_amount_type;
        }
      }
    }

    if (currentDiscount < 0) currentDiscount = 0;

    if (currentDiscount < price) {
      if (currentDiscount < discountedPrice) {
        discountedPrice = currentDiscount;
        appliedPromo = currentPromo;
        discountAmount = currentDiscountAmount;
        discountAmountType = currentDiscountAmountType;
      }
      discounts[currentPromo] = {
        discountAmount: currentDiscountAmount,
        discountAmountType: currentDiscountAmountType
      };
      currentPromo = null;
      currentDiscount = price;
      currentDiscountAmount = 0;
      currentDiscountAmountType = null;
    }

    const itemObj = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.ITEMS];
    if (itemObj[itemId]) {
      const dis = itemObj[itemId];
      if (
        dis.discount_amount_type === CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
      ) {
        const newPrice = price - (dis.discount_amount / 100) * price;
        if (newPrice < currentDiscount) {
          currentDiscount = newPrice;
          currentPromo = itemObj[itemId].parent_id;
          currentDiscountAmount = dis.discount_amount;
          currentDiscountAmountType = dis.discount_amount_type;
        }
      } else {
        const newPrice = price - dis.discount_amount;
        if (newPrice < currentDiscount) {
          currentDiscount = newPrice;
          currentPromo = itemObj[itemId].parent_id;
          currentDiscountAmount = dis.discount_amount;
          currentDiscountAmountType = dis.discount_amount_type;
        }
      }
    }

    if (currentDiscount < 0) currentDiscount = 0;

    if (currentDiscount < price) {
      if (currentDiscount < discountedPrice) {
        discountedPrice = currentDiscount;
        appliedPromo = currentPromo;
        discountAmount = currentDiscountAmount;
        discountAmountType = currentDiscountAmountType;
      }
      discounts[currentPromo] = {
        discountAmount: currentDiscountAmount,
        discountAmountType: currentDiscountAmountType
      };
    }

    discounts['discountedPrice'] = discountedPrice;
    discounts['appliedBin'] = appliedPromo;
    discounts['discountAmount'] = discountAmount;
    discounts['discountAmountType'] = discountAmountType;

    return discounts;
  }
}
